import styled, { keyframes } from 'styled-components';

const IndeterminateFirst = keyframes`
  0% {
      left: -100%;
      width: 100%;
  }
  100% {
      left: 100%;
      width: 10%;
  }
`;

const IndeterminateSecond = keyframes`
  0% {
      left: -150%;
      width: 100%;
  }
  100% {
      left: 100%;
      width: 10%;
  }
`;

export const Indeterminate = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  &::before {
    content: '';
    position: absolute;
    height: 100%;
    background-color: #b3e5fc;
    animation: ${IndeterminateFirst} 1.5s infinite ease-out;
  }
  &::after {
    content: '';
    position: absolute;
    height: 100%;
    background-color: #4fc3f7;
    animation: ${IndeterminateSecond} 1.5s infinite ease-in;
  }
`;

export const LinearActivity = styled.div`
  overflow: hidden;
  width: 100%;
  height: 4px;
  background-color: ${({ theme }) => theme.palette.primary};
`;

export const LoaderContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  ${({ theme }) => theme.breakpoints.up('md')} {
    min-height: 40vh;
  }
  ${({ theme }) => theme.breakpoints.up('lg')} {
    min-height: 50vh;
  }
  ${({ theme }) => theme.breakpoints.up('xl')} {
    min-height: 60vh;
  }
`;
